// network.service.ts
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Network } from '@capacitor/network';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  private networkStatus = new BehaviorSubject<boolean>(true);
  networkStatus$ = this.networkStatus.asObservable();

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    if (isPlatformBrowser(platformId)) {
      this.initializeNetworkListener();
    }
  }

  private async initializeNetworkListener() {
    const status = await Network.getStatus();
    this.networkStatus.next(status.connected);

    Network.addListener('networkStatusChange', (status) => {
      this.networkStatus.next(status.connected);
    });
  }

  isOnline(): boolean {
    return this.networkStatus.value;
  }
}
